import styled from 'styled-components';

export const EditIconWrapper = styled.div`
    position: absolute;
    right: 0;
    top: 0;
    height: 100%;
    width: 40px;
    background: transparent;
    display: ${props => (props.visible ? 'flex' : 'none')};
    place-content: center;
    place-items: center;
`;

export const EditButtonWrapper = styled.div`
    position: relative;
    display: flex;
    border-radius: 30px;
    width: 100%;
    max-width: 250px;
    min-height: 40px;
    align-items: center;
    padding: 0 20px 0 15px;
    overflow: hidden;
    cursor: pointer;
    border: 0.5px dashed ${props => (props.editing ? 'rgba(23, 57, 77, 0.2)' : 'transparent')};
    background-color: ${props => (props.editing ? 'rgb(255,255,255)' : 'transparent')};

    &:not(:hover) {
        ${EditIconWrapper} {
            display: none;
        }
    }

    &:hover {
        border: 0.5px dashed rgba(23, 57, 77, 0.2);
        background-color: rgb(255,255,255);
    }

    input[type="text"] {
        display: block;
        width: 100%;
        cursor: pointer;
        background-color: ${props => (props.editing ? 'rgb(255, 255, 255)' : 'transparent')}
    }

    input[disabled] {
        pointer-events:none
    }
`;
